import React, { useState, useRef, useEffect } from "react";
import "./EmailOtpVerification.css";
import { useDispatch } from "react-redux";
import { setActiveComponent } from "../../../Redux/Slices/activeComponentSlice";
import Cookies from "js-cookie";
import { sendEmailOtp, verifyEmailOtp } from "../../../api/auth";
import { verifyEmail } from "../../../api/auth";
import { signUp } from "../../../api/auth";
import { setAuthTokens } from "../../../api/index";
import Loader from "../../Loader";
import { useNavigate, useSearchParams } from "react-router-dom";

function OtpVerification() {
  const [timer, setTimer] = useState(120); 
  const [canResend, setCanResend] = useState(false);
  const [otpError, setOtpError] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // Snackbar state
  const [snackbar, setSnackbar] = useState({
    show: false,
    message: "",
    type: "info", // 'success', 'error', 'info'
  });
  const length = 6;
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const inputRefs = useRef([]);

  const email = localStorage.getItem("email");
  const [isLoading, setIsLoading] = useState(false);


  // Snackbar helper function
  const showSnackbar = (message, type = "info") => {
    setSnackbar({ show: true, message, type });
    setTimeout(() => {
      setSnackbar({ show: false, message: "", type: "info" });
    }, 3000);
  };

  const handleChange = (element, index) => {
    setOtpError(false);
    const value = element.value.replace(/\D/, "");
    if (!value) return;

    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);

    // Auto focus next
    if (index < length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const updatedOtp = [...otp];
      updatedOtp[index] = "";
      setOtp(updatedOtp);

      // Focus previous
      if (index > 0) {
        inputRefs.current[index - 1].focus();
      }
    } else if (e.key === "Enter") {
      e.preventDefault();
      handleVerifyEmailOtp();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData.getData("text").slice(0, length);
    const updatedOtp = [...otp];
    paste.split("").forEach((char, i) => {
      if (i < length) {
        updatedOtp[i] = char;
        inputRefs.current[i].value = char;
      }
    });
    setOtp(updatedOtp);
  };

  const handleVerifyEmailOtp = async () => {
    if (isLoading) return;
  
    if (otp.includes("")) {
      setOtpError(true);
      showSnackbar("Please enter the full OTP", "error");
      return;
    }
  
    setIsLoading(true);
    const fullOtp = otp.join("");
  
    try {
      const data = await verifyEmailOtp({
        email,
        otp: fullOtp,
      });
      console.log("Verify OTP response:", data);
  
      if (data?.success || data?.statusCode === 200) {
        showSnackbar(data.message ||"OTP Verified Successfully!");
        dispatch(setActiveComponent("emailPassword"));
      } else {
        setOtpError(true);
        showSnackbar(data?.message || "Invalid OTP", "error");
      }
    } catch (error) {
      console.log("error", error);
      setOtpError(true);
      showSnackbar(
        error?.message || "Invalid OTP. Please try again.",
        "error"
      );
    } finally {
      setIsLoading(false);
    }
  };
  
  useEffect(() => {
    if (timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);

      return () => clearInterval(countdown);
    } else {
      setCanResend(true);
    }
  }, [timer]);

  const handleResend = async () => {
    setOtp(new Array(length).fill(""));
    inputRefs.current.forEach((input) => input && (input.value = ""));
  
    try {
      const data = await sendEmailOtp(email);
      console.log("Resend OTP response:", data);
      setTimer(120);
      setCanResend(false);
      setOtpError(false);
      showSnackbar("Verification code sent successfully!", "success");
    } catch (error) {
      console.log("error", error);
      showSnackbar("Failed to resend code. Please try again.", "error");
    }
  };
  

  return (
    <div className="OtpVerification">
      <div className="otpVerificationContainer">
        <span className="getStartedText">Verification</span>
        <span className="signInText2">
          Enter your 6 digits code that you received on your email.
        </span>
        <span className="signInText2">
          {(() => {
            const [localPart, domain] = email?.split("@") || [];
            if (!localPart || !domain) return email;

            const start = localPart.slice(0, 4);
            const end = localPart.slice(-2);
            const masked = "*".repeat(Math.max(localPart.length - 6, 0));

            return `${start}${masked}${end}@${domain}`;
          })()}
        </span>
        <div className="enterMobileOtpContainer">
          <span className="labelText">Email Verification Code</span>
          <div className="otpInputContainer" onPaste={handlePaste}>
            {otp.map((digit, i) => (
              <input
                key={i}
                type="text"
                maxLength="1"
                className={otpError ? "otpInputFalse" : "otpInputTrue"}
                value={otp[i]}
                onChange={(e) => handleChange(e.target, i)}
                onKeyDown={(e) => handleKeyDown(e, i)}
                ref={(el) => (inputRefs.current[i] = el)}
              />
            ))}
          </div>
        </div>
        <span className="forgetPasswordTimer">
          {Math.floor(timer / 60).toString().padStart(2, "0")}:{(timer % 60).toString().padStart(2, "0")}
        </span>
        <button className="btnContainer" onClick={handleVerifyEmailOtp}>
          {isLoading ? <Loader /> : <span className="btnText">Continue</span>}
        </button>
        <span className="resendMobileCodeContainer">
          Didn't receive a code!{" "}
          <button
            className={`resendBtn-${canResend ? "active" : "disabled"}`}
            onClick={handleResend}
            disabled={!canResend}
          >
            Resend
          </button>
        </span>
      </div>

      {/* Snackbar */}
      {snackbar.show && (
        <div className={`snackbar snackbar-${snackbar.type}`}>
          <span className="snackbar-message">{snackbar.message}</span>
        </div>
      )}
    </div>
  );
}

export default OtpVerification;
